import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DoctorLicencePlan } from "../../types/licence";

interface DoctorLicencePlansState {
  byLang: Record<string, DoctorLicencePlan[]>;
}

const initialState: DoctorLicencePlansState = { byLang: {} };

const doctorLicencePlansSlice = createSlice({
  name: "doctorLicencePlans",
  initialState,
  reducers: {
    cacheLicencePlans(
      state,
      action: PayloadAction<{ lang: string; plans: DoctorLicencePlan[] }>
    ) {
      state.byLang[action.payload.lang] = action.payload.plans;
    },
  },
});

export const { cacheLicencePlans } = doctorLicencePlansSlice.actions;

export const selectCachedLicencePlans =
  (lang: string) =>
  (state: {
    doctorLicencePlans: DoctorLicencePlansState;
  }): DoctorLicencePlan[] | null =>
    state.doctorLicencePlans.byLang[lang] ?? null;

export default doctorLicencePlansSlice.reducer;
